exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-source-tree[data-v-8b4ff92a]::-webkit-scrollbar{width:6px}.data-source-tree[data-v-8b4ff92a]  .el-tree-node__content{height:36px}", ""]);

// exports
